import { render, staticRenderFns } from "./DevicesTableResponsiveItem.vue?vue&type=template&id=4319fcc0&scoped=true"
import script from "./DevicesTableResponsiveItem.vue?vue&type=script&lang=js"
export * from "./DevicesTableResponsiveItem.vue?vue&type=script&lang=js"
import style0 from "./DevicesTableResponsiveItem.vue?vue&type=style&index=0&id=4319fcc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4319fcc0",
  null
  
)

export default component.exports